import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { createOrderV2Client } from '../api/client';
import { orderV2QueryKeys } from '../api/queryKeys';
import { OrderTemplateDetail } from '../api/types';

// On-demand single-template fetch (called when the user picks a
// template card on the EntryScreen). Wrapping the call in
// `queryClient.fetchQuery` lets repeated picks of the same template
// hit the cache instead of the network — a small but real benefit
// over the legacy un-cached version. The promise still resolves with
// the detail payload, so call sites are unchanged.
const useOrderTemplate = () => {
  const queryClient = useQueryClient();

  const fetchTemplate = useCallback(
    (templateId: number): Promise<OrderTemplateDetail> =>
      queryClient.fetchQuery<OrderTemplateDetail>({
        queryKey: orderV2QueryKeys.orderTemplate(templateId),
        queryFn: () => createOrderV2Client.getOrderTemplate(templateId),
      }),
    [queryClient],
  );

  return { fetchTemplate };
};

export default useOrderTemplate;
